import type { Tag } from "@/services/api/tags/types";
import { DEFAULT_TAG_COLOR } from "@/services/api/tags";

interface AvailableTagsListProps {
  tags: Tag[];
  onAdd: (tagId: string | number) => void;
  isLoading: boolean;
  searchQuery: string;
  hasAvailableTags: boolean;
}

export function AvailableTagsList({
  tags,
  onAdd,
  isLoading,
  searchQuery,
  hasAvailableTags,
}: AvailableTagsListProps) {
  return (
    <div className="flex-1 overflow-y-auto min-h-[200px] border border-grid-200 rounded-lg">
      {isLoading ? (
        <div className="py-8 text-center text-sm text-ink-500">
          Loading tags...
        </div>
      ) : tags.length === 0 ? (
        <div className="py-8 text-center text-sm text-ink-500 px-4">
          {searchQuery
            ? "No tags match your search."
            : !hasAvailableTags
              ? "No tags available. Create tags in the admin panel first."
              : "All available tags are already selected."}
        </div>
      ) : (
        <div className="divide-y divide-grid-100">
          {tags.map((tag) => (
            <button
              key={tag.id}
              type="button"
              onClick={() => onAdd(tag.id)}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-grid-50 transition-colors text-left group"
            >
              <div
                className="h-3 w-3 rounded-full border border-grid-200 shrink-0"
                style={{ backgroundColor: tag.color ?? DEFAULT_TAG_COLOR }}
              />
              <span className="flex-1 text-sm font-medium text-ink-900">
                {tag.name}
              </span>
              <span className="text-[10px] text-ink-400 opacity-0 group-hover:opacity-100 transition-opacity">
                Click to add
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
